import React from "react";
import ReactDOM from 'react-dom';

import axios from "axios";
import LineSelectAchat from "./LineSelectAchat";


export default class FormProjetAchatModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            caracs: JSON.parse(this.props.caracs),
            delais: JSON.parse(this.props.delais),
            types: JSON.parse(this.props.types),
            chemin: this.props.chemin,
            part1: 1,
            part2: 0,
            part3: 0,
            part4: 0,
            part5: 0,
            part6: 0,
            titre:this.props.projet ? this.props.projet.titre !== "" ? this.props.projet.titre : "" : "",
            description:this.props.projet ? this.props.projet.presentation !== null ?this.props.projet.presentation :"" :"",
            delai:this.props.projet ? this.props.projet.delai !== "" ? this.props.projet.delai : "" : "",
            regions: null,
            departements: null,
            villes: null,
            quartiers: null,
            region: null,
            departement: null,
            ville: null,
            quartier: null,
            type:this.props.projet ? this.props.projet.type !== "" ? this.props.projet.type : "" :"",
            carac:this.props.projet ? this.props.projet.caracteristique !== "" ? this.props.projet.caracteristique.split(" | "):[] : [],
            appartCheckSurfaceExt: false,
            surfaceBienMin:this.props.projet ? this.props.projet.surfaceMin !== null ? this.props.projet.surfaceMin : "" : "",
            surfaceBienMax:this.props.projet ? this.props.projet.surfaceMax !== null ? this.props.projet.surfaceMax : "" :"",
            errorSurfBienMax: false,
            surfaceExtMin:this.props.projet ? this.props.projet.terrainMin !== null ? this.props.projet.terrainMin : "": "",
            surfaceExtMax:this.props.projet ? this.props.projet.terrainMax !== null ? this.props.projet.terrainMax: "" : "",
            errorSurfExtMax: false,
            nbPiece:this.props.projet ? this.props.projet.piece !== null ? this.props.projet.piece : "" : "",
            nbCham:this.props.projet ? this.props.projet.chambre !== null ? this.props.projet.chambre : "" : "",
            tabCham: [],
            messageFlashChambre: null,
            nbSdb:this.props.projet ? this.props.projet.sdb !== null ? this.props.projet.sdb : "" : "",
            prixMin:this.props.projet ? this.props.projet.budgetMin !== null ? this.props.projet.budgetMin : "" : "",
            prixMax:this.props.projet ? this.props.projet.budgetMax !== null ?this.props.projet.budgetMax :"" : "",
            errorPrixMax: false,
            email: "",
            password: "",
            messageFlash: "",
            openPrix: true,
            presentation:this.props.projet ? this.props.projet.presentation !== null ?this.props.projet.presentation :"" : "",
            countArea:0,
            etage:this.props.projet ? this.props.projet.etage !== null ? this.props.projet.etage : "" : "",
            etageTotal:this.props.projet ? this.props.projet.etageTotal !== null ? this.props.projet.etageTotal : "" : "",
            contextProjet: this.props.projet ? this.props.projet.contextProjet !== null ? this.props.projet.contextProjet : "" : "",
            tab: [],
            i: 1,
            nb: [1],
            etat: this.props.projet ? this.props.projet.etat !== null ? this.props.projet.etat : "" : "",
            travau: this.props.projet ? this.props.projet.travaux !== null ? this.props.projet.travaux : "" : "",
            projet:this.props.projet,
            travaux:JSON.parse(this.props.travaux),
        }
        this.handleSelectTiming = this.handleSelectTiming.bind(this);
        this.handleGotoLocal = this.handleGotoLocal.bind(this);
        this.handleSelectRegion = this.handleSelectRegion.bind(this);
        this.handleSelectDepartement = this.handleSelectDepartement.bind(this);
        this.handleSelectVille = this.handleSelectVille.bind(this);
        this.handleSelectQuartier = this.handleSelectQuartier.bind(this);
        this.handleSelectType = this.handleSelectType.bind(this);
        this.handleSelectCarac = this.handleSelectCarac.bind(this);
        this.handleSurfaceBienMin = this.handleSurfaceBienMin.bind(this);
        this.handleSurfaceBienMax = this.handleSurfaceBienMax.bind(this);
        this.handleSelectNbPiece = this.handleSelectNbPiece.bind(this);
        this.handleSelectNbChambre = this.handleSelectNbChambre.bind(this);
        this.handleSelectNbSdb = this.handleSelectNbSdb.bind(this);
        this.handlePrixMin = this.handlePrixMin.bind(this);
        this.handlePrixMax = this.handlePrixMax.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleChangePresentation = this.handleChangePresentation.bind(this);
        this.handleAddContextProjet = this.handleAddContextProjet.bind(this);
        this.handleOnTab = this.handleOnTab.bind(this);
        this.addLineSelectAchat = this.addLineSelectAchat.bind(this);
        this.handleAddEtatBien = this.handleAddEtatBien.bind(this);
        this.handleAddTravaux = this.handleAddTravaux.bind(this);

    }
    async componentDidMount() {
        let types = [];
        let caracs = [];
        if(this.state.chemin === 'habitat'){
            types = this.state.types.filter(type => type.entreprise === 0);
            caracs = this.state.caracs.filter(carac => carac.entreprise === 0);
            this.setState({types,caracs})
        }else{
            types = this.state.types.filter(type => type.entreprise === 1);
            caracs = this.state.caracs.filter(carac => carac.entreprise === 1);
            this.setState({types,caracs})
        }
        if(this.state.projet){
            let {tabCham,tab,nb,i} = this.state;
            for (let i = 1; i < parseInt(this.state.nbPiece); i++) {
                tabCham.push(i);
            }
            if(this.state.prixMin !== ""){
                this.setState({openPrix:true});
            }
            axios.post('/particulier/addLocalisation',{
                projetVente_id: this.state.projet.id
            }).then(res => {
                let {tab} = this.state;
                res.data.map((value,index) => {
                    let t = [];
                    t.push(value.region);
                    t.push(value.departement);
                    t.push(value.ville);
                    if(value.quartier ){
                        t.push(value.quartier);
                    }
                    tab.push(t);
                    if(index > 0){
                        nb.push(1);
                        i++;
                    }
                })
                this.setState({tab,i,nb});
            }).catch(error => {
                console.log(error);
            });
        }
        if(this.state.nbPiece === 0){
            this.setState({nbPiece:"Studio"});
        }
    }

    handleOnTab(value,index) {
        let {tab} = this.state;
        tab[index] = value;
        this.setState({tab});
    }

    handleSelectTiming(value) {
        this.setState({
            delai: value
        });
    }

    handleGotoLocal(e, value) {
        e.preventDefault();
        switch (value) {
            case "timing":
                this.setState({part1: 1, part2: 0, part3: 0, part4: 0, part5: 0, part6: 0}, () => {
                    window.scrollTo(0, 0)
                })
                break;
            case "local":
                if (this.state.delai !== "" && this.state.contextProjet !== "") {

                    axios.post('/location/region', {
                        value: "region",
                    }).then(res => {
                        this.setState({regions: res.data}, () => {
                            this.setState({
                                part1: 2,
                                part2: 1,
                                part3: 0,
                                part4: 0,
                                part5: 0,
                                part6: 0,
                                messageFlash: ""
                            }, () => {
                                window.scrollTo(0, 0)
                            });
                        });
                    }).catch(error => {

                    })
                } else {
                    this.setState({messageFlash: "Veuillez faire un choix."},() => {
                        window.scrollTo(0, 0)
                    })
                }
                break;
            case "type":
                if (this.state.tab[0]) {
                    this.setState({
                        part1: 2,
                        part2: 2,
                        part3: 1,
                        part4: 0,
                        part5: 0,
                        part6: 0,
                        messageFlash: ""
                    }, () => {
                        window.scrollTo(0, 0)
                    })
                } else {
                    this.setState({messageFlash: "Veuillez sélectionner une région, un département et une ville."},() => {
                        window.scrollTo(0, 0)
                    })
                }
                break;
            case "carac":
                if (this.state.type != "") {
                    this.setState({
                        part1: 2,
                        part2: 2,
                        part3: 2,
                        part4: 1,
                        part5: 0,
                        part6: 0,
                        messageFlash: ""
                    }, () => {
                        window.scrollTo(0, 0)
                    })
                } else {
                    this.setState({messageFlash: "Veuillez faire un choix."},() => {
                        window.scrollTo(0, 0)
                    })
                }
                break;
            case "sup":
                this.setState({
                    part1: 2,
                    part2: 2,
                    part3: 2,
                    part4: 2,
                    part5: 1,
                    part6: 0,
                    messageFlash: ""
                }, () => {
                    if (this.state.type === "Appartement") {
                        if (this.state.carac.indexOf("Terrasse") !== -1 || this.state.carac.indexOf("Balcon") !== -1 || this.state.carac.indexOf("Jardin") !== -1) {
                            this.setState({appartCheckSurfaceExt: true})
                        } else {
                            this.setState({appartCheckSurfaceExt: false})
                        }
                    }
                    window.scrollTo(0, 0)
                })
                break;
            case "recap":
                if(this.state.chemin === "entreprise"){
                    if (this.state.surfaceBienMin !== ""){
                        this.setState({
                            part1: 2,
                            part2: 2,
                            part3: 2,
                            part4: 2,
                            part5: 2,
                            part6: 1,
                            messageFlash: ""
                        }, () => {
                            window.scrollTo(0, 0)
                        })
                    }else{
                        this.setState({messageFlash: "Veuillez remplir la surface du bien."}, () => {
                            window.scrollTo(0, 0)
                        });
                    }
                }else{
                    if (this.state.type !== "Terrain") {
                        if (this.state.etage <= this.state.etageTotal) {
                            if (this.state.surfaceBienMin !== "" && this.state.nbPiece !== "") {
                                this.setState({
                                    part1: 2,
                                    part2: 2,
                                    part3: 2,
                                    part4: 2,
                                    part5: 2,
                                    part6: 1,
                                    messageFlash: ""
                                }, () => {
                                    window.scrollTo(0, 0)
                                })

                            } else {
                                this.setState({messageFlash: "Veuillez remplir la surface et le nombre de pièces du bien."}, () => {
                                    window.scrollTo(0, 0)
                                });
                            }
                        } else {
                            this.setState({messageFlash: "L'étage doit être inférieur à l'étage total."}, () => {
                                window.scrollTo(0, 0)
                            });
                        }
                    } else {
                        this.setState({
                            part1: 2,
                            part2: 2,
                            part3: 2,
                            part4: 2,
                            part5: 2,
                            part6: 1,
                            messageFlash: "",
                            surfaceBienMin: "",
                            surfaceBienMax: "",
                            nbPiece: "",
                            nbCham: "",
                            nbSdb: "",
                        }, () => {
                            window.scrollTo(0, 0)
                        })
                    }
                }
                break;
        }
    }

    handleSelectRegion(value) {
        axios.post('/location/departement', {
            region: value,
        }).then(res => {
            this.setState({departements: res.data, region: value});
        }).catch(error => {

        })
    }

    handleSelectDepartement(value) {
        axios.post('/location/ville', {
            departement: value,
        }).then(res => {
            this.setState({villes: res.data, departement: value});
        }).catch(error => {

        })
    }

    handleSelectVille(value) {
        axios.post('/location/quartier', {
            ville: value,
        }).then(res => {
            this.setState({quartiers: res.data, ville: value});
        }).catch(error => {

        })
    }

    handleSelectQuartier(value) {
        this.setState({quartier: value});
    }

    handleSelectType(value) {
        this.setState({type: value});
    }

    handleSelectCarac(value) {
        let {carac} = this.state;
        if (carac.indexOf(value) !== -1) {
            const i = carac.indexOf(value);
            carac.splice(i, 1);
            if(carac.indexOf('Balcon') === -1 && carac.indexOf('Térrasse') === -1 && carac.indexOf('Jardin') === -1){
                this.setState({
                    surfaceExtMin: "",
                    surfaceExtMax: ""
                });
            }
        } else {
            carac.push(value)

        }
        this.setState({carac: carac});
    }

    handleSurfaceBienMin(value) {
        this.setState({
            surfaceBienMin: value,
            surfaceBienMax: value,
        })
    }

    handleSurfaceBienMax(value) {
        const {surfaceBienMin} = this.state;
        if (parseInt(surfaceBienMin) < parseInt(value)) {
            this.setState({errorSurfBienMax: false});
        } else {
            this.setState({
                errorSurfBienMax: true
            })
        }
        this.setState({surfaceBienMax: value})
    }

    handleSurfaceExtMin(value) {
        this.setState({
            surfaceExtMin: value,
            surfaceExtMax: value,
        })
    }

    handleSurfaceExtMax(value) {
        const {surfaceExtMin} = this.state;
        if (parseInt(surfaceExtMin) < parseInt(value)) {
            this.setState({errorSurfExtMax: false});
        } else {
            this.setState({
                errorSurfExtMax: true
            })
        }
        this.setState({surfaceExtMax: value})
    }

    handleSelectNbPiece(value) {
        if (value !== "Studio" && value !== "+5") {
            let tabCham = [];
            for (let i = 1; i < parseInt(value); i++) {
                tabCham.push(i);
            }
            this.setState({nbPiece: value, tabCham: tabCham});
        } else {
            let tabCham = [];
            this.setState({nbPiece: value, tabCham: tabCham});
        }
    }

    handleSelectNbChambre(value) {
        const {nbPiece} = this.state;
        if (nbPiece == 1) {
            this.setState({nbCham: value, messageFlashChambre: null});
        } else if (nbPiece === "+5") {
            this.setState({nbCham: value, messageFlashChambre: null});
        } else {
            if (nbPiece > value) {
                this.setState({nbCham: value, messageFlashChambre: null});
            } else {
                this.setState({messageFlashChambre: "Le nombre de chambre doit être inferieur au nombre de pièce."});
            }
        }
    }

    handleSelectNbSdb(value) {
        this.setState({nbSdb: value});
    }

    handlePrixMin(value) {
        this.setState({
            prixMin: value,
            prixMax: value,
        })
    }

    handlePrixMax(value) {
        this.setState({prixMax: value})
    }

    handleOpenPrix(value) {
        if (value === "oui") {
            this.setState({openPrix: true})
        } else {
            this.setState({
                openPrix: true, prixMin: "",
                prixMax: ""
            })
        }
    }

    handleChangePresentation(value) {
        if(value.length <= 400){
            this.setState({presentation: value});
        }
    }

    async handleSave(e) {
        e.preventDefault();
        let {
            email,
            password,
            delai,
            carac,
            type,
            region,
            departement,
            ville,
            quartier,
            nbCham,
            nbPiece,
            nbSdb,
            prixMax,
            prixMin,
            surfaceBienMin,
            surfaceBienMax,
            surfaceExtMin,
            surfaceExtMax,
            presentation,
            titre,
            contextProjet,
            etat,
            travau,
            tab,
            chemin
        } = this.state;
        if(titre === ""){
            titre =  type+ " "+ tab[0][2]
        }
            axios.post('/particulier/projet/update', {
                achat:"achat",
                chemin:chemin,
                id:this.props.projet ? this.props.projet.id : null,
                email: email,
                tr: password,
                delai: delai,
                caracteristiques: carac,
                type: type,
                region: region,
                departement: departement,
                ville: ville,
                quartier: quartier,
                lead_user_id:0,
                lead_type:"classique",
                chambre: nbCham,
                piece: nbPiece,
                sdb: nbSdb,
                budgetMin: prixMin,
                budgetMax: prixMax,
                surfaceMin: surfaceBienMin,
                surfaceMax: surfaceBienMax,
                terrainMin: surfaceExtMin,
                terrainMax: surfaceExtMax,
                presentation: presentation,
                titre:titre,
                contextProjet: contextProjet,
                travaux: travau,
                etat: etat,
                tab:tab,
            }).then(res => {
                if(res.data === 1){
                    window.location.reload();
                }
            }).catch(error => {
                console.log(error);
            })

    }

    validateEmail(email) {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/
        );
    };

    handleAddContextProjet(value) {
        this.setState({contextProjet: value});
    }

    addLineSelectAchat(e) {
        e.preventDefault()
        let {nb, i} = this.state;
        nb.push(1);
        i++;
        this.setState({nb, i})
    }

    handleAddEtatBien(value) {
        this.setState({etat: value});
    }

    handleAddTravaux(value) {
        this.setState({travau: value});
    }

    render() {
        let {part1, part2, part3, part4, part5, part6} = this.state;
        return (
            <div className="formulaire">
                <div className="tunnel">
                    <ul>
                        <li className={part1 === 1 ? "selected tunel" : part1 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>1</p>
                            </div>
                            <p>Timing</p>
                        </li>
                        <li className={part1 === 2 ? "hrline finish" : "hrline"}>
                            <hr/>
                        </li>
                        <li className={part2 === 1 ? "selected tunel" : part2 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>2</p>
                            </div>
                            <p>Localisation</p>
                        </li>
                        <li className={part2 === 2 ? "hrline finish" : "hrline"}>
                            <hr/>
                        </li>
                        <li className={part3 === 1 ? "selected tunel" : part3 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>3</p>
                            </div>
                            <p>Type de bien</p>
                        </li>
                        <li className={part3 === 2 ? "hrline finish" : "hrline"}>
                            <hr/>
                        </li>
                        <li className={part4 === 1 ? "selected tunel" : part4 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>4</p>
                            </div>
                            <p>Caractéristiques</p>
                        </li>
                        <li className={part4 === 2 ? "hrline finish" : "hrline"}>
                            <hr/>
                        </li>
                        <li className={part5 === 1 ? "selected tunel" : part5 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>5</p>
                            </div>
                            <p>Superficie et prix</p>
                        </li>
                        <li className={part5 === 2 ? "hrline finish" : "hrline"}>
                            <hr/>
                        </li>
                        <li className={part6 === 1 ? "selected tunel" : part6 === 2 ? "finish tunel" : "tunel"}>
                            <div className="blockNb">
                                <p>6</p>
                            </div>
                            <p>Récapitulatif</p>
                        </li>
                    </ul>
                </div>
                {
                    this.state.messageFlash !== "" &&
                    <div className="alert alert-warning">
                        <p>{this.state.messageFlash}</p>
                    </div>
                }
                <div className="ecran">
                    {
                        part1 === 1 &&
                        <>
                            <div className="form">
                                <h2>Souhaitez-vous Acheter ou Louer ?</h2>
                                <div className="block">
                                    <div onClick={() => this.handleAddContextProjet('Acheter')}
                                         className={this.state.contextProjet !== null ? this.state.contextProjet === "Acheter" ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}>
                                        Acheter
                                    </div>
                                    <div onClick={() => this.handleAddContextProjet('Louer')}
                                         className={this.state.contextProjet !== null ? this.state.contextProjet === "Louer" ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}>
                                        Louer
                                    </div>
                                </div>
                                <h2>A quel horizon souhaitez-vous avoir trouvé votre bien ?</h2>
                                <div className="block">
                                    {
                                        this.state.delais.map((value, index) => (
                                            <div key={index}
                                                 className={this.state.delai !== null ? this.state.delai === value.name ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}
                                                 onClick={() => this.handleSelectTiming(value.name)}>
                                                {value.name}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="action">
                                <a href="" onClick={(e) => this.handleGotoLocal(e, 'local')}>Suivant ></a>
                            </div>
                        </>
                    }
                    {
                        part2 === 1 &&
                        <>
                            <div className="form localisation">
                                <h2>Où se situe votre recherche ?</h2>
                                {
                                    this.state.nb.map((value, index) => (
                                        <div key={index}>
                                            <LineSelectAchat index={index} i={this.state.i} regions={this.state.regions}
                                                             tab={this.state.tab} handleOnTab={this.handleOnTab}/>
                                        </div>
                                    ))
                                }
                                <a href="" className="addLine" onClick={(e) => this.addLineSelectAchat(e)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.013" height="15.013" viewBox="0 0 15.013 15.013">
                                        <g id="Icon_ionic-md-add-circle-outline" data-name="Icon ionic-md-add-circle-outline" transform="translate(-3.375 -3.375)">
                                            <path id="Tracé_8" data-name="Tracé 8" d="M18.2,15.1H15.1v3.1H13.58V15.1h-3.1V13.58h3.1v-3.1H15.1v3.1h3.1Z" transform="translate(-3.457 -3.457)" fill="#2f2f2f"/>
                                            <path id="Tracé_9" data-name="Tracé 9" d="M10.881,4.891A5.988,5.988,0,1,1,6.645,6.645a5.966,5.966,0,0,1,4.237-1.754m0-1.516a7.506,7.506,0,1,0,7.506,7.506,7.505,7.505,0,0,0-7.506-7.506Z" fill="#2f2f2f"/>
                                        </g>
                                    </svg>
                                    <span>Ajouter</span>
                                </a>
                                <div className="action">
                                    <a href="" className="gray"
                                       onClick={(e) => this.handleGotoLocal(e, 'timing')}>{`< Retour`}</a>
                                    <a href="" onClick={(e) => this.handleGotoLocal(e, 'type')}>Suivant ></a>
                                </div>
                            </div>
                        </>
                    }
                    {
                        part3 === 1 &&
                        <>
                            <div className="form">
                                <h2>Quel type de bien recherchez vous ?</h2>
                                <div className="block">

                                    {
                                        this.state.types.map((value, index) => (
                                            <div key={index}
                                                 className={this.state.type !== null ? this.state.type === value.name ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}
                                                 onClick={() => this.handleSelectType(value.name)}>
                                                {value.name}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="action">
                                <a href="" className="gray" onClick={(e) => this.handleGotoLocal(e, 'local')}>{`< Retour`}</a>
                                <a href="" onClick={(e) => this.handleGotoLocal(e, 'carac')}>Suivant ></a>
                            </div>
                        </>
                    }
                    {
                        part4 === 1 &&
                        <>
                            <div className="form">
                                <h2>Quelles sont les caractéristiques du bien recherché ?</h2>
                                <div className="block">
                                    {
                                        this.state.caracs.map((value, index) => (

                                            <div key={index}
                                                 className={this.state.carac.indexOf(value.name) != -1 ? "selected btn formbtn" : "btn formbtn"}
                                                 onClick={() => this.handleSelectCarac(value.name)}>
                                                {value.name}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="action">
                                <a href="" className="gray" onClick={(e) => this.handleGotoLocal(e, 'type')}>{`< Retour`}</a>
                                <a href="" onClick={(e) => this.handleGotoLocal(e, 'sup')}>Suivant ></a>
                            </div>
                        </>
                    }
                    {
                        part5 === 1 &&
                        <>
                            <div className="form">
                                <h2>Superficie et prix du bien recherché ?</h2>
                                {
                                    this.state.type !== "Terrain" &&
                                    <div className="formblock">
                                        <label htmlFor="">Surface du bien</label>
                                        <input type="text" placeholder="Surface min. m²"
                                               value={this.state.surfaceBienMin}
                                               onChange={(e) => this.handleSurfaceBienMin(e.target.value)}/>
                                        <input type="text" placeholder="Surface max. m²"
                                               value={this.state.surfaceBienMax}
                                               onChange={(e) => this.handleSurfaceBienMax(e.target.value)}/>
                                        {
                                            this.state.errorSurfBienMax &&
                                            <div className="message">
                                                La surface max. doit être supérieur à la surface min.
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    this.state.chemin !== "entreprise" &&
                                    <>
                                     {
                                    this.state.type !== "Appartement" ?

                                        <div className="formblock">
                                            <label htmlFor="">Surface des extérieurs</label>
                                            <input type="text" placeholder="Surface min. m²"
                                                   value={this.state.surfaceExtMin}
                                                   onChange={(e) => this.handleSurfaceExtMin(e.target.value)}/>
                                            <input type="text" placeholder="Surface max. m²"
                                                   value={this.state.surfaceExtMax}
                                                   onChange={(e) => this.handleSurfaceExtMax(e.target.value)}/>
                                            {
                                                this.state.errorSurfExtMax &&
                                                <div className="message">
                                                    La surface max. doit être supérieur à la surface min.
                                                </div>
                                            }
                                        </div>
                                        :
                                        this.state.appartCheckSurfaceExt ?
                                            <div className="formblock">
                                                <label htmlFor="">Surface des extérieurs</label>
                                                <input type="text" placeholder="Surface min. m²"
                                                       value={this.state.surfaceExtMin}
                                                       onChange={(e) => this.handleSurfaceExtMin(e.target.value)}/>
                                                <input type="text" placeholder="Surface max. m²"
                                                       value={this.state.surfaceExtMax}
                                                       onChange={(e) => this.handleSurfaceExtMax(e.target.value)}/>
                                                {
                                                    this.state.errorSurfExtMax &&
                                                    <div className="message">
                                                        La surface max. doit être supérieur à la surface min.
                                                    </div>
                                                }
                                            </div>
                                            : null
                                }
                                {
                                    this.state.type !== "Terrain" &&

                                    <div className="formblock disflex">
                                        <label htmlFor="">Nombre de pièces</label>
                                        <div className="blockNbPiece">
                                            <div
                                                className={this.state.nbPiece === "Studio" ? "nbpiece selected" : "nbpiece"}
                                                onClick={() => this.handleSelectNbPiece("Studio")}>Studio
                                            </div>
                                            <div className={this.state.nbPiece == "1" ? "nbpiece selected" : "nbpiece"}
                                                 onClick={() => this.handleSelectNbPiece("1")}>1
                                            </div>
                                            <div className={this.state.nbPiece == "2" ? "nbpiece selected" : "nbpiece"}
                                                 onClick={() => this.handleSelectNbPiece("2")}>2
                                            </div>
                                            <div className={this.state.nbPiece == "3" ? "nbpiece selected" : "nbpiece"}
                                                 onClick={() => this.handleSelectNbPiece("3")}>3
                                            </div>
                                            <div className={this.state.nbPiece == "4" ? "nbpiece selected" : "nbpiece"}
                                                 onClick={() => this.handleSelectNbPiece("4")}>4
                                            </div>
                                            <div
                                                className={this.state.nbPiece == "+5" ? "nbpiece selected" : "nbpiece"}
                                                onClick={() => this.handleSelectNbPiece("+5")}>+5
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.type !== "Terrain" ?
                                    this.state.nbPiece !== "" && this.state.nbPiece !== "Studio" ?

                                        this.state.nbPiece !== "+5" ?
                                            this.state.nbPiece === "1" ?
                                                <>
                                                <div className="formblock disflex">
                                                    <label htmlFor="">Nombre de chambres</label>
                                                    <div className="blockNbPiece">
                                                        <div
                                                            className={this.state.nbCham == "1" ? "nbpiece selected" : "nbpiece"}
                                                            onClick={() => this.handleSelectNbChambre("1")}>1
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                this.state.messageFlashChambre !== null &&
                                                    <div className="message displaynone">
                                                        {this.state.messageFlashChambre}
                                                    </div>
    }
                                                </>
                                                :
                                                <>
                                                <div className="formblock disflex">
                                                    <label htmlFor="">Nombre de chambres</label>
                                                    <div className="blockNbPiece">
                                                        {
                                                            this.state.tabCham.map((value, index) => (
                                                                <div key={index}
                                                                     className={this.state.nbCham === index + 1 ? "nbpiece selected" : "nbpiece"}
                                                                     onClick={() => this.handleSelectNbChambre(index + 1)}>{index + 1}</div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                this.state.messageFlashChambre !== null &&
                                                    <div className="message displaynone">
                                                        {this.state.messageFlashChambre}
                                                    </div>
    }
                                                </>
                                            :
                                            <>
                                            <div className="formblock disflex">
                                                <label htmlFor="">Nombre de chambres</label>
                                                <div className="blockNbPiece">
                                                    <div
                                                        className={this.state.nbCham == "1" ? "nbpiece selected" : "nbpiece"}
                                                        onClick={() => this.handleSelectNbChambre("1")}>1
                                                    </div>
                                                    <div
                                                        className={this.state.nbCham == "2" ? "nbpiece selected" : "nbpiece"}
                                                        onClick={() => this.handleSelectNbChambre("2")}>2
                                                    </div>
                                                    <div
                                                        className={this.state.nbCham == "3" ? "nbpiece selected" : "nbpiece"}
                                                        onClick={() => this.handleSelectNbChambre("3")}>3
                                                    </div>
                                                    <div
                                                        className={this.state.nbCham == "4" ? "nbpiece selected" : "nbpiece"}
                                                        onClick={() => this.handleSelectNbChambre("4")}>4
                                                    </div>
                                                    <div
                                                        className={this.state.nbCham == "+5" ? "nbpiece selected" : "nbpiece"}
                                                        onClick={() => this.handleSelectNbChambre("+5")}>+5
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.state.messageFlashChambre !== null &&
                                                <div className="message displaynone">
                                                    {this.state.messageFlashChambre}
                                                </div>
                                            }

                                            </>
                                        :
                                        null
                                        :null
                                }
                                {
                                    this.state.type !== "Terrain" &&
                                    this.state.nbPiece !== "" &&
                                    <div className="formblock disflex">
                                        <label htmlFor="">Nombre de salle de bain</label>
                                        <div className="blockNbPiece">
                                            {
                                                this.state.nbPiece !== "+5" ?
                                                    this.state.tabCham.map((value,index) => (
                                                        <div key={index} className={this.state.nbSdb == (index+1) ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb(index+1)}>{index+1 == 5 ? "+5" :index+1}
                                                        </div>
                                                    ))
                                                    :
                                                    <>
                                                        <div className={this.state.nbSdb === "1" ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb("1")}>1
                                                        </div>
                                                        <div className={this.state.nbSdb === "2" ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb("2")}>2
                                                        </div>
                                                        <div className={this.state.nbSdb === "3" ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb("3")}>3
                                                        </div>
                                                        <div className={this.state.nbSdb === "4" ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb("4")}>4
                                                        </div>
                                                        <div className={this.state.nbSdb === "+5" ? "nbpiece selected" : "nbpiece"}
                                                             onClick={() => this.handleSelectNbSdb("+5")}>+5
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </div>
                                }

                                    </>
                                }

                                <div
                                    className={`formblock displayBlock ${this.state.type === "Terrain" ? "terrain" : ""}`}>
                                    <div className="prixfull">
                                        <label htmlFor="">Budget</label>
                                        <div className="prixblock">
                                            <input type="number" placeholder="Min. €" value={this.state.prixMin}
                                                   onChange={(e) => this.handlePrixMin(e.target.value)}/>
                                            <input type="number" placeholder="Max. €" value={this.state.prixMax}
                                                   onChange={(e) => this.handlePrixMax(e.target.value)}/>
                                        </div>
                                        {
                                            this.state.errorPrixMax &&
                                            <div className="message">
                                                Le prix max. doit être supérieur au prix min.
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    this.state.chemin !== "entreprise" &&
                                        <div className="formblock disflex">
                                            <label htmlFor="">Type de bien</label>
                                            <div className="blockNbPiece typeForm">
                                                <div onClick={() => this.handleAddEtatBien('Neuf')}
                                                    className={this.state.etat !== null ? this.state.etat === "Neuf" ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}>Neuf
                                                </div>
                                                <div onClick={() => this.handleAddEtatBien('Ancien')}
                                                    className={this.state.etat !== null ? this.state.etat === "Ancien" ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}>Ancien
                                                </div>
                                            </div>
                                        </div>
                                }
                                {
                                    this.state.etat === "Ancien" && this.state.contextProjet === "Acheter" ?
                                        <div className="formblock disflex">
                                            <label htmlFor="">Travaux</label>
                                            <div className="blockNbPiece travauxForm">
                                                {
                                                    this.state.travaux.map((value, index) => (
                                                        <div key={index}
                                                             onClick={() => this.handleAddTravaux(value.name)}
                                                             className={this.state.travau !== null ? this.state.travau === value.name ? "selected btn formbtn" : "btn formbtn" : "btn formbtn"}>{value.name}</div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        : null
                                }

                                <div className={`formblock displayBlock ${this.state.type === "Terrain" ? "terrain" : ""}`}>
                                    <label htmlFor="">Descriptif de votre recherche de bien (Limité à 400 caractères)</label>
                                    <textarea name="presentation" value={this.state.presentation}
                                              onChange={(e) => this.handleChangePresentation(e.target.value)}></textarea>
                                </div>
                            </div>
                            <div className="action">
                                <a href="" className="gray" onClick={(e) => this.handleGotoLocal(e, 'carac')}>{`< Retour`}</a>
                                <a href="" onClick={(e) => this.handleGotoLocal(e, 'recap')}>Suivant ></a>
                            </div>
                        </>
                    }
                    {
                        part6 === 1 &&
                        <>
                            <div className="form ">
                                <h2>Récapitulatif de votre recherche</h2>
                                <div className="blockRecap">
                                    <p>Type de bien :</p>
                                    <p>{this.state.contextProjet} | {this.state.type} | {this.state.etat}</p>
                                </div>
                                {
                                    this.state.tab.map((value, index) => (
                                        <div key={index} className="blockRecap">
                                            <p>Localisation {index + 1} :</p>
                                            <p>
                                                {value[2]} {value[3] ? ` | ${value[3]}` : ""}
                                            </p>
                                        </div>
                                    ))
                                }
                                <div className="blockRecap">
                                    <p>Superficie :</p>
                                    <p>{this.state.surfaceBienMin}{this.state.surfaceBienMin !== this.state.surfaceBienMax ? ` / ${this.state.surfaceBienMax} m² habitable` : " m² habitable "}
                                        {this.state.surfaceExtMin !== "" ? ` | ${this.state.surfaceExtMin}${this.state.surfaceExtMin !== this.state.surfaceExtMax ? ` / ${this.state.surfaceExtMax}` : ""} m² d'extérieur` : ""}</p>

                                </div>
                                <div className="blockRecap">
                                    <p>Configuration :</p>
                                    <p>{this.state.nbPiece === "Studio" ? this.state.nbPiece : `${this.state.nbPiece} pièce${this.state.nbPiece > 1 ? "s" : ""}`}
                                        {this.state.nbCham !== "" ? ` | ${this.state.nbCham} chambre${this.state.nbCham > 1 ? "s" : ""}` : ""}
                                        {this.state.nbSdb !== "" ? ` | ${this.state.nbSdb} Salle${this.state.nbSdb > 1 ? "s" : ""} de bain` : ""}</p>
                                </div>
                                {this.state.carac[0] &&
                                <div className="blockRecap">
                                    <p>Caractéristiques :</p>
                                    <p>
                                        {
                                            this.state.carac.map((value, index) => (
                                                <span key={index}>
                                                {value} {index < this.state.carac.length - 1 ? " | " : ""}
                                            </span>
                                            ))
                                        }
                                    </p>
                                </div>
                                }
                                <div className="blockRecap">
                                    <p>Budget :</p>
                                    <p>{this.state.prixMin !== "" ? `${this.state.prixMin} - ${this.state.prixMax} €` : "non communiqué"}</p>
                                </div>
                                <div className="blockRecap">
                                    <p>Délai de réalisation :</p>
                                    <p>{this.state.delai}</p>
                                </div>
                                {this.state.presentation !== "" &&
                                    <div className="blockRecap">
                                        <p>Descriptif :</p>
                                        <p>{this.state.presentation}</p>
                                    </div>
                                }
                                {this.state.travau !== null &&
                                <div className="blockRecap">
                                    <p>Travaux :</p>
                                    <p>{this.state.travau}</p>
                                </div>
                                }
                                <div className="blockRecap titre">
                                    <p>Titre de votre recherche</p>
                                    <input type="text" value={this.state.titre} onChange={(e) => this.setState({titre:e.target.value})}/>
                                </div>
                            </div>
                            <div className="action">
                                <a href="" className="gray" onClick={(e) => this.handleGotoLocal(e, 'sup')}>{`< Retour`}</a>
                                <a href="" onClick={(e) => this.handleSave(e)}>Valider ></a>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}
